
import { defuFn } from 'E:/develop/集团官网/zzrb-gw/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
